import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CookiePolicyLink = styled(Link)`
  color: var(--primary-color);
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;
